/* ⚛ REACT */
import { useEffect, useState } from "react";

/* 📁 ASSETS*/
import { PictureEdit, Excluir } from "../../Assets/icons";

/* 🎨 STYLES */
import { Container, FileInput, UploadButton, ImageIcons, PreviewImage, ExcluirIcon} from "./styles";

/* 🔧 UTILS */
import { isValidaProp } from "../../util/validate";

const InputImage = (props) => {
    const [color, setColor] = useState( isValidaProp(props.value) ? '#006560' : '#C7C7C7');
    const [file, setFile] = useState(null)
    
    useEffect(() => {
        setColor(isValidaProp(props.value) ? '#006560' : '#C7C7C7');
    },[props.value])

    function ApplyHover (){
        color !== '#006560' && color !== '#FF3939' ? setColor('#A3A3A3') : setColor(color);
    }

    function ApplyBlur(){
        color !== '#006560' && color !== '#FF3939' ? setColor('#C7C7C7') : setColor(color);
    }

    const handleFileChange = (e) => {
        if(e.target.files[0]){
            setColor('#006560')
        }
        setFile(e.target.files[0])
        props.onchange(e.target.files[0])
    };

    return(
        <Container $borderColor={color} onMouseOver={()=>ApplyHover()} onMouseOut={()=>ApplyBlur()}>
            <FileInput type='file' accept="image/png, image/jpeg" onChange={handleFileChange}/>
            <ExcluirIcon src={Excluir} onClick={()=> props.deleteImage()}/>
            <UploadButton>
                {file?
                    <PreviewImage src={URL.createObjectURL(file)} alt="Preview" />
                : props.value ? <PreviewImage src={props.value} alt="Preview" />
                :<></>}
            </UploadButton>
            <ImageIcons src={PictureEdit} color={color}/>
        </Container>
    )
}

export default InputImage;